export const SORT_OPTIONS = ["Most common variant", "Fastest", "Slowest"];

export const VARIANTS_PER_PAGE = 10;

// Variant grouping mode identifiers.
export const VARIANT_MODES = {
  EXACT: "exact",
  COMPRESSED: "compressed",
  LOOP_COMPRESSED: "loop_compressed",
};

export const VARIANT_MODE_OPTIONS = [
  { value: VARIANT_MODES.EXACT, label: "Exact" },
  { value: VARIANT_MODES.COMPRESSED, label: "Compressed" },
  { value: VARIANT_MODES.LOOP_COMPRESSED, label: "Loop-compressed" },
];

// Repetition-display modes for loop-compressed variants.
export const REPETITION_DISPLAY = {
  EXACT: "exact",
  ABSTRACT: "abstract",
};

export const REPETITION_DISPLAY_OPTIONS = [
  { value: REPETITION_DISPLAY.EXACT, label: "Exact repetition count" },
  { value: REPETITION_DISPLAY.ABSTRACT, label: "Abstract repetition count" },
];

// Placeholder string used by the backend when repetition_display=abstract.
export const ABSTRACT_REPETITION_PLACEHOLDER = "N";

// Display labels for the repetition-metrics strip and its inline section
// heading.
export const METRIC_LABELS = {
  SECTION: "Variant Metrics",
  UNIQUE_ACTIVITIES: "Unique Activities",
  REPETITION_COUNT: "Repetition Count",
  REPEATED_ACTIVITIES: "Repeated Activities",
  MEDIAN_LOOP_REPEATS: "Median Loop Repeats",
  LOOPS: "Loops",
  REPETITIONS_RANGE: "Repetitions (Min–Max)",
};

export const METRIC_TOOLTIPS = {
  UNIQUE_ACTIVITIES:
    "Number of distinct activity types present in this variant, regardless of how many times each occurs.",
  REPETITION_COUNT:
    "Repeated occurrences beyond the first occurrence of each activity. " +
    "Calculated as Event Count minus Unique Activities.",
  REPEATED_ACTIVITIES:
    "Number of distinct activity types that occur more than once in this variant.",
  MEDIAN_LOOP_REPEATS:
    "The case-weighted median number of times each loop pattern repeats across " +
    "the cases in this variant — the same value shown on each loop badge.",
  LOOPS:
    "Number of repeating loop patterns identified in this variant.",
  REPETITIONS_RANGE:
    "Minimum and maximum number of times the loop pattern(s) repeated across " +
    "the cases grouped into this variant — the same underlying statistic as " +
    "Median Loop Repeats, shown as a range instead of the typical value.",
};
